import { detect } from 'detect-browser/index.js'

export class Browser {
  constructor() {
    this.info = detect()

    const os = detect().os.toLowerCase()
    const name = detect().name.toLowerCase()
    const isTouch = navigator.maxTouchPoints > 0 // needed for Request Desktop Site on mobile devices
    const isIPad =
      navigator.platform.includes('iPad') || (os.includes('mac') && isTouch)
    const isIPhone = navigator.platform.includes('iPhone')

    this.browserName = detect().name
    this.os = os.includes('windows')
      ? 'Windows'
      : os.includes('mac') // && !isTouch  - don't treat iPad as mobile
        ? 'Mac'
        : os.includes('ios') // || (this.includes(os, 'mac') && isTouch) - don't treat iPad as mobile
          ? 'iOS'
          : os.includes('android') || (os.includes('linux') && isTouch)
            ? 'Android'
            : os
    this.name =
      name.includes('chrome') || name.includes('crios')
        ? 'Chrome'
        : name.includes('edge')
          ? 'Edge'
          : name.includes('safari') || name === 'ios'
            ? 'Safari'
            : name.includes('firefox')
              ? 'Firefox'
              : name

    this.version = this.info.version
    const versionParts = this.version.split('.')
    this.majorVersion = versionParts[0]
    this.minorVersion = versionParts[1]
    this.revision = versionParts.length > 2 ? versionParts[2] : '0'

    this.isIPad = isIPad
    this.isIPhone = isIPhone
    this.isIOS = this.os === 'iOS' || this.isIPhone || this.isIPad
    this.isAndroid = this.os === 'Android'
    this.isMobile = this.os === 'Android' || this.os === 'iOS'
    this.isDesktop = !this.isMobile || isIPad
    this.userAgent = navigator.userAgent

    this.upgradeRequired =
      (this.userAgent.includes('OS 14_2') ||
        (this.majorVersion == 14 &&
          this.minorVersion == 0 &&
          this.revision == 1)) &&
      this.isIOS

    this.teleHealthEnabled =
      !this.upgradeRequired &&
      ((this.os == 'iOS' && this.name == 'Safari' && this.majorVersion >= 12) ||
      (this.os === 'Windows' &&
        (this.name == 'Chrome' ||
          this.name == 'Firefox' ||
          this.name == 'Edge' ||
          this.name == 'Safari')) ||
      (this.os === 'Mac' &&
        (this.name == 'Safari' ||
          this.name == 'Chrome' ||
          this.name == 'Firefox' ||
          this.name == 'Edge')) ||
      (this.os === 'Android' &&
        (this.name == 'Chrome' || this.name == 'Firefox'))
        ? true
        : false)
  }
}
